import { render, staticRenderFns } from "./SubId.vue?vue&type=template&id=41cf6ad7&"
import script from "./SubId.vue?vue&type=script&lang=js&"
export * from "./SubId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports